import React, { useState, useEffect } from 'react';

export default function NumberIncrementer({
  start,
  highlight = true,
  double = false,
}) {
  const [number, setNumber] = useState(start);
  const formatNumber = num => num.toLocaleString();

  useEffect(() => {
    const intervalId = setInterval(() => {
      const random = Math.floor(Math.random() * 4) + 1;
      setNumber(number => number + random);
    }, 2500);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <span style={{ background: highlight ? 'rgba(255,235,0,.3)' : 'transparent' }}>
      {formatNumber(number * (double ? 2 : 1))}
    </span>
  );
}
